import { render, staticRenderFns } from "./AccountSettingsWindow.vue?vue&type=template&id=117ef242&"
import script from "./AccountSettingsWindow.vue?vue&type=script&lang=js&"
export * from "./AccountSettingsWindow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports